import { render, staticRenderFns } from "./InvoicesToBePaid.vue?vue&type=template&id=13122bd8&"
import script from "./InvoicesToBePaid.vue?vue&type=script&lang=js&"
export * from "./InvoicesToBePaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports